export const copyData = (data: any) => {
    return data ? JSON.parse(JSON.stringify(data)) : null;
};
